type Translate = (key: string) => string;

const historySubjectKeys: Record<string, string> = {
  '✅ Resolved: Agent Reconnected - Alert Auto-Cleared': 'historySubjects.agentReconnected',
};

/** Localize known history subjects for display while preserving unknown originals. */
export function translateHistorySubject(subject: string, translate: Translate): string {
  const key = historySubjectKeys[subject.trim()];
  return key ? translate(key) : subject;
}
